import { Fragment } from 'react'

import { isFolderFile } from '../../../utils/file'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderCell } from './FileAttachedItemsModalTableRow.utils'

import * as styles from './FileAttachedItemsModalTableRow.module.css'

function FileAttachedItemsModalTableRow({
  columns,
  disabled,
  emptyColumnSize,
  isSelected,
  item,
  onClick,
  onClickFolder,
  ...restProps
}) {
  const { handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions({ ...restProps, item, onClick })

  function handleClick() {
    if (isFolderFile(item)) {
      onClickFolder?.(item.id)
    } else {
      onClick?.(item.id)
    }
  }

  const className = useTableRowModClassName({
    className: styles.FileAttachedItemsModalTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={className}
      key={item.id}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableRowActions
        checked={isSelected}
        disabled={disabled || isFolderFile(item)}
        onChange={handleSelect}
      />
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            item,
            name: column.name,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default FileAttachedItemsModalTableRow
